export const INVOICE_STATUSES = ['PAID', 'PARTIAL', 'PENDING', 'OVERDUE', 'CANCELLED'];
export const GENDERS = ['Male', 'Female', 'Other'];
//# sourceMappingURL=invoice.js.map